// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "biWebStatic/js/" + chunkId + "." + {"8":"c42435b7","653":"658e9e02"}[chunkId] + ".js";
};